import React from "react";

const IframePreview = ({ url, onClose }) => {
  if (!url) return null;
console.log("Selected url:", url);  

  return (
    <div style={overlayStyle}>
      <div style={modalStyle}>
        <div className="d-flex justify-content-between align-items-center mb-2">
          <h5 className="mb-0">Preview</h5>
          <button className="btn btn-sm btn-outline-secondary" onClick={onClose}>
            Close
          </button>
        </div>
        <iframe
          src={url}
          title="View Content"
          width="100%"
          height="500px"
          style={{ border: "1px solid #ccc", borderRadius: "4px", height: "80vh",}}
        ></iframe>
      </div>
    </div>
  );
};

const overlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  zIndex: 1050, // Make sure it's above everything
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

const modalStyle = {
  backgroundColor: "#fff",
  padding: "20px",
  borderRadius: "8px",
  width: "97%",
  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.3)",
  position: "relative",
};

export default IframePreview;
